import React from "react";
import styled from "styled-components";
import "../flickity.css";
import Flickity from "react-flickity-component";
import { Flex, Box } from "rebass";
import ProjectFadeInTitle from "../components/ProjectFadeInTitle";

interface IProps {
  img1?: string | undefined;
  img2?: string | undefined;
  img3?: string | undefined;
  img4?: string | undefined;
  img5?: string | undefined;
  title?: string | undefined;
  className?: string | undefined;
  //images?: Array<string> | undefined;
  component1?: JSX.Element | undefined;
  component2?: JSX.Element | undefined;
  component3?: JSX.Element | undefined;
  component4?: JSX.Element | undefined;
}

const flickityOptions = {
  initialIndex: 1,
  pageDots: true,
  fullscreen: true,
  lazyLoad: 1,
  wrapAround: true,
  arrowShape:
    "M78.1,48.2L51.8,23.9l-5.4,6.5c8.8,7.7,19.4,13.6,26.4,17.5l-0.2,0.5c-9.2-1-23.2-2.1-34.8-2.1H21.9v7.3h15.9 c11.6,0,25.6-0.9,34.8-1.8l0.2,0.5c-7.1,3.9-17.6,9.6-26.4,17.3l5.4,6.5l26.3-24.3V48.2z",
};

const Carousel = (props: IProps) => {
  return (
    <div>
      {props.title !== undefined && (
        <Flex flexWrap="wrap" variant="container">
          <Box>
            <ProjectFadeInTitle
              word1={props.title}
              className={props.className}
            />
          </Box>
        </Flex>
      )}
      <Flickity
        className={"carousel"}
        options={flickityOptions} // takes flickity options {}
        reloadOnUpdate
      >
        {props.img1 !== undefined && (
          <Box
            pr={"1px"}
            width={[1 / 1, 1 / 2, 1 / 3]}
            variant="wrapperImgBorder"
          >
            <img src={props.img1} alt="img 1" />
          </Box>
        )}
        {props.img2 !== undefined && (
          <Box
            pr={"1px"}
            width={[1 / 1, 1 / 2, 1 / 3]}
            variant="wrapperImgBorder"
          >
            <img src={props.img2} alt="img 2" />
          </Box>
        )}
        {props.img3 !== undefined && (
          <Box
            pr={"1px"}
            width={[1 / 1, 1 / 2, 1 / 3]}
            variant="wrapperImgBorder"
          >
            <img src={props.img3} alt="img 3" />
          </Box>
        )}
        {props.img4 !== undefined && (
          <Box
            pr={"1px"}
            width={[1 / 1, 1 / 2, 1 / 3]}
            variant="wrapperImgBorder"
          >
            <img src={props.img4} alt="img 4" />
          </Box>
        )}
        {props.img5 !== undefined && (
          <Box
            pr={"1px"}
            width={[1 / 1, 1 / 2, 1 / 3]}
            variant="wrapperImgBorder"
          >
            <img src={props.img5} alt="img 5" />
          </Box>
        )}
        {props.component1 !== undefined && (
          <Box
            className="carousel-cell"
            width={[1 / 1, 1 / 1, 2 / 3, 2 / 3, 1 / 3]}
            maxWidth={["76.4rem", "76.4rem", "76.4rem", "88.4rem"]}
            mx={[2, 3]}
          >
            {props.component1}
          </Box>
        )}
        {props.component2 !== undefined && (
          <Box
            className="carousel-cell"
            width={[1 / 1, 1 / 1, 2 / 3, 2 / 3, 1 / 3]}
            maxWidth={["76.4rem", "76.4rem", "76.4rem", "88.4rem"]}
            mx={[2, 3]}
          >
            {props.component2}
          </Box>
        )}
        {props.component3 !== undefined && (
          <Box
            className="carousel-cell"
            width={[1 / 1, 1 / 1, 2 / 3, 2 / 3, 1 / 3]}
            maxWidth={["76.4rem", "76.4rem", "76.4rem", "88.4rem"]}
            mx={[2, 3]}
          >
            {props.component3}
          </Box>
        )}
        {props.component4 !== undefined && (
          <Box
            className="carousel-cell"
            width={[1 / 1, 1 / 1, 2 / 3, 2 / 3, 1 / 3]}
            maxWidth={["76.4rem", "76.4rem", "76.4rem", "88.4rem"]}
            mx={[2, 3]}
          >
            {props.component4}
          </Box>
        )}
      </Flickity>
    </div>
  );
};

function ProjectsCarousel(props: IProps) {
  return (
    <Wrapper>
      <Carousel
        title={props.title}
        className={props.className}
        img1={props.img1}
        img2={props.img2}
        img3={props.img3}
        img4={props.img4}
        img5={props.img5}
        component1={props.component1}
        component2={props.component2}
        component3={props.component3}
        component4={props.component4}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100vw;
  height: 100%;
  margin-bottom: 64px;
  outline: 0;
  & .anim-title {
    margin-bottom: 0;
  }
`;

export default ProjectsCarousel;
